import axios from 'axios';
import config from '../../config';

const baseUrl = `${config.baseUrl}/api/participante_visita/archivos`;

const participanteVisitaService = {
  getArchivosParticipantes: async () => {
    try {
      const response = await axios.get(baseUrl);
      return response.data;
    } catch (error) {
      console.error("Error al obtener los archivos de los participantes:", error);
      throw error;
    }
  },
};

export default participanteVisitaService;
